import { downloadCSV } from 'react-admin';
import { unparse as convertToCSV } from 'papaparse';
import moment from 'moment';

import resources from '../../constants/resources';
import formats from '../../constants/formats';

const exporter = (records, fetchRelatedRecords) => {
  fetchRelatedRecords(records, 'supplierId', resources.SUPPLIER).then(suppliers => {
    const data = records.map(({ id, supplierId, timeDate }) => ({
      ID: id,
      'Purchase Order': id,
      Supplier: (suppliers[supplierId] || {}).companyName,
      'Order Date': moment(timeDate).format(formats.DATE_TIME_EXPORT),
    }));
    const csv = convertToCSV({
      data,
    });
    downloadCSV(csv, `purchase_orders_${moment().format(formats.MOMENT)}`);
  });
};

export default exporter;
